import { render, staticRenderFns } from "./showImgList.vue?vue&type=template&id=88e6a7b2&scoped=true&"
import script from "./showImgList.vue?vue&type=script&lang=js&"
export * from "./showImgList.vue?vue&type=script&lang=js&"
import style0 from "./showImgList.vue?vue&type=style&index=0&id=88e6a7b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e6a7b2",
  null
  
)

export default component.exports